/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Flags from 'country-flag-icons/react/3x2';
import { DomTomIsoCodes, swiftCode } from './countries';
import { DomTomFlag } from './DomTomFlag';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { colorPalette } from '../../colorPalette';
export const CountryFlag = ({ isoCode, countryName, cssClassFlag, cssClassTitle }) => {
    const getSwiftCode = (code) => swiftCode[code];
    const Flag = Flags[getSwiftCode(isoCode)];
    if (Flag) {
        return (React.createElement(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
            } },
            React.createElement(Typography, { component: "span", sx: Object.assign({ fontSize: '1.4rem', color: colorPalette.gray900 }, cssClassTitle) }, countryName),
            React.createElement(Box, { sx: Object.assign({ width: '20px', maxHeight: '12px', margin: '8px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.5)' }, cssClassFlag) }, !DomTomIsoCodes.includes(isoCode) ? React.createElement(Flag, { title: countryName }) : React.createElement(DomTomFlag, { title: countryName }))));
    }
    return null;
};
